<nav class="navbar navbar-expand-lg nav-color sticky-top desktop-version p-0">
	<div class="container h-100">
		<a class="navbar-brand" routerLink="/">
			<img src="assets/image/biztory-logo.png" width="auto" style="height: 100%" />
		</a>
		<!-- <button class="navbar-toggler ml-auto" type="button">
			<a class="pointer mb navbar-right" data-toggle="dropdown" >
				<div class="box pointer"><span class="material-icons sheild align-top">security</span>S</div>
			</a>
		</button> -->
		<ng-container *ngIf="isLogin$ | async">
			<div class="menu-trigger d-flex align-items-center pointer" [matMenuTriggerFor]="menu">
				<div class="mx-auto">
					<div class="bg-primary profile-Icon">
						<span class="text-light fs-5">{{ (userName$ | async).charAt(0) | uppercase }} </span>
					</div>
					<!-- TODO add section and ngif if have profile picture-->
				</div>
				<mat-icon class="text-white" svgIcon="chevron-down"></mat-icon>
			</div>

			<mat-menu #menu="matMenu">
				<div class="d-flex flex-column gy-1">
					<a mat-menu-item routerLink="/settings" class="text-decoration-none">
						<mat-icon>settings</mat-icon><span>{{ 'register.settings' | translate }}</span>
					</a>
					<mat-divider></mat-divider>
					<a mat-menu-item routerLink="/logout" class="text-decoration-none pt-1">
						<mat-icon>exit_to_app</mat-icon>
						<span>{{ 'register.logout' | translate }}</span>
					</a>
				</div>
			</mat-menu>
		</ng-container>
	</div>
</nav>
<!-- <div>
</div> -->
<div class="{{ background }}content" role="main">
	<!-- <div class="formContainer"> -->
	<div class="container dropdown-container">
		<!-- <div class="formContainer"> -->
		<!-- <select name="language" [(ngModel)]="selectedValue" (ngModelChange)="useLanguage()" style="display: flex; margin-left: auto;">
					<option *ngFor="let lang of langs" [ngValue]="lang.value">{{lang.viewValue}}</option>
				</select> -->
		<!-- <div class="col-md-12" style="text-align: right;">
			<mat-form-field appearance="fill">
				<mat-select [(ngModel)]="selectedValue" (ngModelChange)="useLanguage()">
					<mat-option *ngFor="let lang of langs" [value]="lang.value">{{lang.viewValue}}</mat-option>
				</mat-select>
			</mat-form-field>
		</div> -->
		<router-outlet></router-outlet>
		<!-- </div> -->
	</div>
	<!-- </div> -->
	<!-- Footer -->
	<!-- <footer>
		Love Angular?&nbsp;
		<a href="https://github.com/angular/angular" target="_blank" rel="noopener"> Give our repo a star.
			<div class="github-star-badge">
				<svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
					viewBox="0 0 24 24">
					<path d="M0 0h24v24H0z" fill="none" />
					<path
						d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
				</svg>
				Star
			</div>
		</a>
		<a href="https://github.com/angular/angular" target="_blank" rel="noopener">
			<svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
				<path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" fill="#1976d2" />
				<path d="M0 0h24v24H0z" fill="none" />
			</svg>
		</a>
	</footer> -->
</div>
